import React, { useMemo } from "react";
import {
  ObjectCorrespondenceStatusCssClasses,
  ObjectCorrespondenceStatusTitles,
  CorrespondenceStatusTypeEnum
} from "../../ObjectsUIHelpers";
import { FormattedMessage } from "react-intl";

const getValue = (type) => {
  if (type) {
    if (type === "None" || type === "0") return 0;
    if (type === "UnRead" || type === "1") return 1;
    if (type === "Readed" || type === "2") return 2;
    if (type === "Answered" || type === "3") return 3;
    if (type === "InProgress" || type === "4") return 4;
    if (type === "Waiting" || type === "5") return 5;
    if (type === "Referred" || type === "6") return 6;
    if (type === "Archived" || type === "7") return 7;
  } else return 0;
};

const setRow = (row) => {
  if (row.status !== undefined) {
    return (
      < span
        className={`label label-lg label-light-${ObjectCorrespondenceStatusCssClasses[getValue(row.status)]} label-inline`
        }
      >
        <FormattedMessage id={ObjectCorrespondenceStatusTitles[getValue(row.status)]} />
      </span >
    )
  }
  else if (row.fromStatus !== undefined) {
    return (
      <>
        {"از وضعیت  "}
        < span
          className={`label label-lg label-light-${ObjectCorrespondenceStatusCssClasses[getValue(row.fromStatus)]} label-inline`
          }
        >
          <FormattedMessage id={ObjectCorrespondenceStatusTitles[getValue(row.fromStatus)]} />
        </span >

        {"   به وضعیت   "}
        < span
          className={`label label-lg label-light-${ObjectCorrespondenceStatusCssClasses[getValue(row.toStatus)]} label-inline`
          }
        >
          <FormattedMessage id={ObjectCorrespondenceStatusTitles[getValue(row.toStatus)]} />
        </span >

      </>
    )
  }
}

export const CorrespondenceStatusColumnFormatter = (cellContent, row) => setRow(row);

export const indexN = (cellContent, row, index) => {
  return (<div>{index}</div>)
}